module.exports = __webpack_public_path__ + "static/img/suprajit.d6a562d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/suprajit.png
// module id = UVeJ
// module chunks = 1